// src/utils/browserIdentifier.ts

const EVALUATION_BROWSER_ID_KEY = "emasajid_evaluation_browser_id";

/**
 * Returns one stable browser identifier for mosque evaluation.
 * This is NOT personal user data.
 *
 * Note:
 * - It remains same in the same browser.
 * - If user clears localStorage or uses another browser/device, a new identifier is created.
 */
export function getEvaluationBrowserIdentifier(): string {
  const existing = localStorage.getItem(EVALUATION_BROWSER_ID_KEY);

  if (existing && existing.trim()) {
    return existing;
  }

  // crypto.randomUUID is supported in modern browsers.
  const newId =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  localStorage.setItem(EVALUATION_BROWSER_ID_KEY, newId);

  return newId;
}